import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { NavigationService } from '../services/navigation.service';
import { SessionService } from '../services/session.service';
import { map } from 'rxjs/operators';

export const unAuthGuard: CanActivateFn = () => {
  const nav = inject(NavigationService);

  return inject(SessionService).getOneSession$.pipe(
    map(session => {
      if (!session) return true;
      nav.navigateTo(['/budgets']);
      return false;
    }),
  );
};
